import { useEffect } from "react";
import { useSiteData } from "@/context/SiteDataContext";

const SEOInjection = () => {
  const data = useSiteData();

  useEffect(() => {
    if (!data) return;
    const injectScripts = () => {
      // 1. Set Title & Meta
        if (data.site_title) document.title = data.site_title;
        
        let metaDesc = document.querySelector('meta[name="description"]');
        if (!metaDesc) {
          metaDesc = document.createElement('meta');
          metaDesc.setAttribute('name', 'description');
          document.head.appendChild(metaDesc);
        }
        metaDesc.setAttribute('content', data.meta_description || "");

        // OG + Twitter tags (update existing static tags, don't append new ones)
        const ogFields: Array<[string, string, string | undefined]> = [
          ['og:title',             'property', data.og_title],
          ['og:description',       'property', data.og_description],
          ['og:image',             'property', data.og_image_url],
          ['og:url',               'property', data.canonical_url],
          ['twitter:title',        'name',     data.og_title],
          ['twitter:description',  'name',     data.og_description],
          ['twitter:image',        'name',     data.og_image_url],
          ['twitter:site',         'name',     data.twitter_handle ? `@${data.twitter_handle}` : undefined],
        ];

        ogFields.forEach(([content, attr, value]) => {
          if (!value) return;
          const selector = attr === 'property'
            ? `meta[property="${content}"]`
            : `meta[name="${content}"]`;
          const el = document.querySelector(selector);
          if (el) el.setAttribute('content', value);
        });

        if (data.canonical_url) {
          const canonical = document.querySelector('link[rel="canonical"]');
          if (canonical) canonical.setAttribute('href', data.canonical_url);
        }

        if (data.keywords) {
          let kwMeta = document.querySelector('meta[name="keywords"]') as HTMLMetaElement | null;
          if (!kwMeta) {
            kwMeta = document.createElement('meta');
            kwMeta.setAttribute('name', 'keywords');
            document.head.appendChild(kwMeta);
          }
          kwMeta.setAttribute('content', data.keywords);
        }

        // 2. Google Analytics
        if (data.google_analytics_id) {
          const gaScript = document.createElement("script");
          gaScript.async = true;
          gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${data.google_analytics_id}`;
          document.head.appendChild(gaScript);

          const gaConfig = document.createElement("script");
          gaConfig.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${data.google_analytics_id}');
          `;
          document.head.appendChild(gaConfig);
        }

        // 3. Microsoft Clarity
        if (data.clarity_id) {
          const clarityScript = document.createElement("script");
          clarityScript.type = "text/javascript";
          clarityScript.innerHTML = `
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "${data.clarity_id}");
          `;
          document.head.appendChild(clarityScript);
        }
    };

    injectScripts();
  }, [data]);

  return null;
};

export default SEOInjection;
